module.exports = __webpack_public_path__ + "img/s_4.ad967e06.png";